import { Col, ColProps } from 'antd';
import { FC } from 'react';
const TwoItemColumn: FC<ColProps> = (props) => {
  // console.log(props);
  return (
    <Col
      className="policy-wrap"
      xs={{ span: 24, offset: 0 }}
      sm={{ span: 24, offset: 0 }}
      md={{ span: 24, offset: 0 }}
      lg={{ span: 12 }}
      {...props}
    />
  );
};

export default TwoItemColumn;
